import { createContext, useContext } from 'react';

// Lets a routed page (e.g. OrderX V4's review/match split-screen step) ask the
// app shell (MainLayout in App.js) to collapse the left main menu for more
// horizontal room, without MainLayout needing to know about any specific page.
export const SidebarContext = createContext({
  collapsed: false,
  setCollapsed: () => {},
});

export const useSidebarContext = () => useContext(SidebarContext);
